<template>
  <el-row class="tasks shortcuts" style="display: flex">
    <template v-if="!background_images">
      <template v-if="background_image_url_state">
        <img class="bg_image" :src="background_image_url_state" />
      </template>
      <template v-else>
        <img
          class="bg_image"
          :src="require('@/assets/static/images/bg/' + background_image)"
        />
      </template>
      <div
        class="shortcut-background-overlay"
        style="
          background-color: #dee8f2;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0.5;
        "
      ></div>
    </template>
    <div
      v-else
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
      :style="'background-color: ' + background_images"
    ></div>
    <el-col
      class="project_body vertical_scrollbar"
      :span="left_col"
      :data-col-span="left_col"
      :style="taskPanelOpen ? openListStyle : null"
    >
      <div class="project_title">
        <h3>{{ title }}</h3>
        <div class="project-settings">
          <!-- <div class="project-settings__list" @click="muteOrUnmute">
                        <div v-html="mute.svg"></div>
                        <p>{{mute.text}}</p>
                    </div> -->
          <!-- <div class="project-settings__list">
                        <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.23405 4.50696L3.38502 2.35598V11.9475C3.38502 12.0554 3.42788 12.1589 3.50416 12.2351C3.58045 12.3114 3.68391 12.3543 3.79179 12.3543C3.89967 12.3543 4.00313 12.3114 4.07942 12.2351C4.1557 12.1589 4.19855 12.0554 4.19855 11.9475V2.35192L6.3536 4.50777C6.42998 4.58405 6.53353 4.62685 6.64147 4.62678C6.74941 4.6267 6.8529 4.58375 6.92917 4.50737C7.00545 4.43099 7.04825 4.32744 7.04818 4.2195C7.0481 4.11156 7.00515 4.00807 6.92877 3.93179L4.08954 1.09257L4.08141 1.08443C4.04363 1.04654 3.99874 1.01647 3.94933 0.995945C3.89991 0.975424 3.84693 0.964855 3.79342 0.964844H3.79179C3.73236 0.96483 3.67365 0.977865 3.61981 1.00303C3.56597 1.02819 3.51832 1.06487 3.48021 1.11047L0.658064 3.93179C0.620298 3.96961 0.590351 4.0145 0.569933 4.06389C0.549514 4.11329 0.539025 4.16622 0.539063 4.21966C0.5391 4.27311 0.549665 4.32603 0.570153 4.37539C0.590641 4.42476 0.620652 4.4696 0.658471 4.50737C0.696291 4.54513 0.741178 4.57508 0.790571 4.5955C0.839964 4.61592 0.892895 4.62641 0.946342 4.62637C0.999789 4.62633 1.05271 4.61577 1.10207 4.59528C1.15143 4.57479 1.19628 4.54478 1.23405 4.50696ZM13.6754 8.81217L11.5244 10.9631V1.37161C11.5244 1.26373 11.4816 1.16027 11.4053 1.08398C11.329 1.0077 11.2255 0.964844 11.1176 0.964844C11.0098 0.964844 10.9063 1.0077 10.83 1.08398C10.7537 1.16027 10.7109 1.26373 10.7109 1.37161V10.9672L8.55502 8.81136C8.5172 8.77359 8.47231 8.74364 8.42292 8.72323C8.37352 8.70281 8.32059 8.69232 8.26715 8.69236C8.15921 8.69243 8.05572 8.73538 7.97944 8.81176C7.90317 8.88814 7.86037 8.99169 7.86044 9.09964C7.86052 9.20758 7.90347 9.31107 7.97985 9.38734L10.8191 12.2266L10.8272 12.2347C10.8651 12.2726 10.9102 12.3027 10.9597 12.3232C11.0093 12.3437 11.0624 12.3543 11.116 12.3543H11.1176C11.1771 12.3542 11.2358 12.3412 11.2896 12.316C11.3434 12.2909 11.3911 12.2542 11.4292 12.2087L14.2506 9.38734C14.2894 9.34981 14.3204 9.30493 14.3417 9.2553C14.363 9.20568 14.3743 9.1523 14.3747 9.09829C14.3752 9.04428 14.3649 8.99072 14.3444 8.94073C14.324 8.89074 14.2938 8.84532 14.2556 8.80713C14.2174 8.76894 14.172 8.73873 14.122 8.71828C14.072 8.69783 14.0184 8.68754 13.9644 8.688C13.9104 8.68847 13.857 8.6997 13.8074 8.72101C13.7578 8.74233 13.7129 8.77332 13.6754 8.81217Z" fill="white"/>
                        </svg>
                        <p>Sort</p>
                    </div> -->
        </div>
      </div>
      <div class="tasks_body" v-if="tasks.length > 0">
        <ShortcutsTask
          v-for="task in tasks"
          :key="task._id"
          :task="task"
          :done="task.done"
          @change_complete="change_complete"
        />
      </div>
      <div class="remove__list" v-else>
        <span>
          {{ $t("list.messages.not_tasks") }}
        </span>
      </div>
    </el-col>

    <router-view></router-view>
  </el-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import File from "../utils/aws";
// import Task from "../components/tasks/Task.vue"
import ShortcutsTask from "../components/app/ShortcutsTask.vue";
import { EventEmitter } from "../main";

export default {
  data() {
    return {
      tasks: [],
      title: "",
      message: "",
      left_col: 24,
      mute: {
        bool: false,
        svg: `
                        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.428558 4.19048H3.76189L7.09523 0.857147H8.76189V13.3571H7.09523L3.76189 10.0238H0.428558V4.19048ZM1.26189 9.19048H4.10689L7.44022 12.5238H7.92856V1.69048H7.44022L4.10689 5.02381H1.26189V9.19048ZM10.3986 9.46381L12.7561 7.10715L10.3986 4.75048L10.9886 4.16048L13.3452 6.51798L15.7019 4.16048L16.2911 4.75048L13.9344 7.10715L16.2911 9.46381L15.7019 10.053L13.3452 7.69631L10.9886 10.053L10.3986 9.46381Z" fill="white"/>
                        </svg>`,
        text: this.$t("list.mute"),
      },
      background_image_url: "",
    };
  },
  components: {
    // Task
    ShortcutsTask,
  },
  watch: {
    $route(to) {
      this.tasks = [];
      // setTimeout(() => {
      this.render();
      // }, 200)
      if (this.$route.params.task_id) {
        this.math_cols(true);
      } else {
        this.math_cols(false);
      }
    },
    get_change_shortcuts_render() {
      this.tasks = [];
      // setTimeout(() => {
      this.render();
      // }, 200)
    },
  },
  computed: {
    ...mapGetters([
      "getProjects",
      "getTasks",
      "getUserData",
      "get_change_shortcuts_render",
    ]),
    background_image() {
      return this.$store.state.key.background_image;
    },
    background_images() {
      let image = this.$store.state.key.background_images.find(
        (e) => e.image_name == this.$store.state.key.background_image
      );
      if (image) {
        return image.color ? image.color : false;
      } else {
        return false;
      }
    },
    background_image_url_state() {
      return this.$store.state.key.background_image_url;
    },
    taskPanelOpen() {
      return Boolean(this.$route.params.task_id);
    },
    openListStyle() {
      return {
        width: "auto",
        maxWidth: "none",
        flex: "1 1 auto",
        minWidth: "420px",
      };
    },
  },
  mounted() {
    this.tasks = [];
    this.render();
    if (this.$route.params.task_id) {
      this.math_cols(true);
    } else {
      this.math_cols(false);
    }
  },
  methods: {
    ...mapMutations(["backgroundImageUrl"]),
    ...mapActions(["socket_completed_task"]),
    async backgroundImageRender() {
      this.background_image_url = "";
      if (
        !this.background_images.some(
          (e) => e.image_name == this.getUserData.background_image
        )
      ) {
        if (
          localStorage.getItem(
            "background_image_" + this.getUserData.background_image
          )
        ) {
          this.background_image_url = localStorage.getItem(
            "background_image_" + this.getUserData.background_image
          );
          this.backgroundImageUrl(this.background_image_url);
        } else {
          const aws = new File();
          this.background_image_url = await aws.read(
            `Users/${this.getUserData._id}/background_image/${this.getUserData.background_image}`
          );
          this.backgroundImageUrl(this.background_image_url);
          this.toDataUrl(this.background_image_url, (myBase64) => {
            localStorage.removeItem(
              "background_image_" + this.getUserData.background_image
            );
            localStorage.setItem(
              "background_image_" + this.getUserData.background_image,
              myBase64
            );
          });
        }
      } else {
        this.backgroundImageUrl(this.background_image_url);
      }
    },
    toDataUrl(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    },
    math_cols(show) {
      if (show) {
        this.left_col = 16;
        if (innerWidth <= 540) {
          this.left_col = 24;
        } else if (innerWidth <= 768) {
          this.left_col = 14;
        }
      } else {
        this.left_col = 24;
      }
    },
    render() {
      if (this.$route.params.shortcuts == "today") {
        this.title = this.$t("app.shortcuts.today");
      } else if (this.$route.params.shortcuts == "assigned_to_me") {
        this.title = this.$t("app.shortcuts.assigned_to_me");
      } else if (this.$route.params.shortcuts == "medium_priority") {
        this.title = this.$t("app.shortcuts.medium_priority");
      } else if (this.$route.params.shortcuts == "high_priority") {
        this.title = this.$t("app.shortcuts.high_priority");
      }

      this.getProjects.forEach((project) => {
        if (this.getTasks[project._id]) {
          if (this.getTasks[project._id].length > 0) {
            this.getTasks[project._id].forEach((task) => {
              if (task.done == false) {
                if (this.$route.params.shortcuts == "today") {
                  if (task.assign.date) {
                    if (this.$w_date_parse(task.assign.date) == "Today") {
                      this.tasks.push(task);
                    }
                  }
                } else if (this.$route.params.shortcuts == "assigned_to_me") {
                  if (task.assign.user_id) {
                    if (task.assign.user_id == this.getUserData._id) {
                      this.tasks.push(task);
                    }
                  }
                } else if (this.$route.params.shortcuts == "medium_priority") {
                  if (task.priority) {
                    if (task.priority == "Medium") {
                      this.tasks.push(task);
                    }
                  }
                } else if (this.$route.params.shortcuts == "high_priority") {
                  if (task.priority) {
                    if (task.priority == "High") {
                      this.tasks.push(task);
                    }
                  }
                }
              }
            });
          }
        }
      });
    },
    muteOrUnmute() {
      if (!this.mute.bool) {
        this.mute = {
          bool: true,
          svg: `
                        <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.667114 3.49978H4.00045L7.33378 0.166443H9.00045V12.6664H7.33378L4.00045 9.33311H0.667114V3.49978ZM1.50045 8.49977H4.34545L7.67878 11.8331H8.16711V0.999776H7.67878L4.34545 4.33311H1.50045V8.49977ZM10.6371 8.77311L12.9946 6.41644L10.6371 4.05978L11.2271 3.46978L13.5838 5.82728L15.9404 3.46978L16.5296 4.05978L14.1729 6.41644L16.5296 8.77311L15.9404 9.36227L13.5838 7.00561L11.2271 9.36227L10.6371 8.77311Z" fill="white"/>
                        </svg>
                        `,
          text: this.$t("list.unmute"),
        };
      } else {
        this.mute = {
          bool: false,
          svg: `
                        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.428558 4.19048H3.76189L7.09523 0.857147H8.76189V13.3571H7.09523L3.76189 10.0238H0.428558V4.19048ZM1.26189 9.19048H4.10689L7.44022 12.5238H7.92856V1.69048H7.44022L4.10689 5.02381H1.26189V9.19048ZM10.3986 9.46381L12.7561 7.10715L10.3986 4.75048L10.9886 4.16048L13.3452 6.51798L15.7019 4.16048L16.2911 4.75048L13.9344 7.10715L16.2911 9.46381L15.7019 10.053L13.3452 7.69631L10.9886 10.053L10.3986 9.46381Z" fill="white"/>
                        </svg>`,
          text: this.$t("list.mute"),
        };
      }
    },
    change_complete({ complete, task_id, project_id }) {
      this.socket_completed_task({
        complete: complete,
        task_id: task_id,
        project_id: project_id,
      });
      this.tasks = [];
      this.render();
    },
  },
};
</script>
